import PopoverMixin from './popoverMixins.js'
  export default {
    mixins: [PopoverMixin]
  }


/** WEBPACK FOOTER **
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/Popover.vue
 **/